export const config = {
    nextRacesCount: 3
}